import React from 'react'

import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Filler,
  Legend,
} from 'chart.js';
import { Line } from 'react-chartjs-2';
import faker from '@faker-js/faker';

ChartJS.register(
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Filler,
  Legend
);

export const options = {
  elements: {
    point:{
        radius: 0
    }
      },
  maintainAspectRatio: false,
  scales: {
    y: {
      display: false,
    },
    x:{
      display: false
    }
  },
  responsive: true,
  labels: {
    display: false
  },
  plugins: {
    legend: {
      display: false,
    },        
    title: {
      display: false,
    },
  },
};

const labels = ['January', 'February', 'March', 'April', 'May', 'June', 'July'];

export const data = {
  labels,
  datasets: [
    {
      fill: true,
      label: 'CPU',
      data: [50, 38, 48, 40, 50, 47, 40],
      borderColor: 'rgba(255,200,5,255)',
      backgroundColor: 'rgba(255,200,5,0.2)',
      borderWidth: 2,
    },
  ],
};

const ChartAdoptionsNums = () => {
  return (
    <div style={{width: "150px", height: "40px"}}>
        <Line options={options} data={data} />
    </div>
  )
}

export default ChartAdoptionsNums